const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
const SET_OPTION_TRADING_LEVEL = 'SET_OPTION_TRADING_LEVEL';
const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
const SET_SELECTED_LABEL = "SET_SELECTED_LABEL";
const SET_DAY_TRADE = "SET_DAY_TRADE"

const accountData = {
    accountType: 'marginAcc',
    dayTrade: 'N',

    optionTradingLevel: {
        level1: false,
        level2: false,
        level3: false,
        level4: true,
        level5: false,
        noOptions: false,
    },
    selectedOption: 'level4',
    selectedLabel: 'level4',
};

export const setSelectedLabel = (label) => ({
    type: SET_SELECTED_LABEL,
    payload: label,
});

export const setSelectedOption = (selectedOption) => ({
    type: SET_SELECTED_OPTION,
    payload: selectedOption,
});

export const setAccountType = (accountType) => ({
    type: SET_ACCOUNT_TYPE,
    payload: accountType,
});

export const setDayTrade = (dayTrade) => ({
    type: SET_DAY_TRADE,
    payload: dayTrade,
});

const accountReducer = (state = accountData, action) => {
    switch (action.type) {
        case SET_ACCOUNT_TYPE:
            return {
                ...state,
                accountType: action.payload,
            };
        case SET_DAY_TRADE:
            return {
                ...state,
                dayTrade: action.payload,
            };
        case SET_OPTION_TRADING_LEVEL:
            return {
                ...state,
                optionTradingLevel: action.payload,
            };
        case SET_SELECTED_OPTION:
            return {
                ...state,
                selectedOption: action.payload,
            };
        case SET_SELECTED_LABEL:
            return {
                ...state,
                selectedLabel: action.payload,
            };
        default:
            return state;
    }
};

export default accountReducer;